import React, { useEffect, useState } from "react"
import MScienceCarousel from "../blocks/m_science_carousel"
import DfbSpinner from "../ui-kit/dfb_spinner"
import { getMostVisitedCombinedCached } from "../../services/content"

const MScienceCarouselPss = ({
  headline,
  source,
  space_before_class,
  space_after_class,
}) => {
  const [items, setItems] = useState(null)

  const init = async () => {
    try {
      const pages = await getMostVisitedCombinedCached()
      const content =
        source === "category"
          ? pages.mostVisitedByCategory
          : pages.mostVisitedByTag
      setItems(content)
    } catch (err) {
      console.error("Hide carousel since dynamic content cannot be loaded", err)
      setItems([])
    }
  }

  useEffect(() => {
    init()
  }, [])

  useEffect(() => {
    if (items && items.length && window.upgradeAllBehaviours) {
      // ensure slider and images are initialized by ui kit
      window.upgradeAllBehaviours()
    }
  }, [items])

  if (!items) {
    return (
      <section className="m-ScieneCarousel">
        <div className="m-ScieneCarousel-wrapper">
          <div className="m-ScieneCarousel-container">
            <DfbSpinner type="continuous" autoLoop={true} />
          </div>
        </div>
      </section>
    )
  }

  if (items.length === 0) {
    return null
  }

  return (
    <MScienceCarousel
      data={{
        uid: "pss",
        headline: headline,
        collection: items,
        space_before_class: space_before_class,
        space_after_class: space_after_class,
      }}
    />
  )
}

export default MScienceCarouselPss
